var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PurchaseService from '../../../api/PurchaseService';
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supplierorganOptions = [];
        _this.supplierdepotOptions = [];
        return _this;
    }
    BillHeader.prototype.watchFormDataOrganId = function (newVal, oldVal) {
        this.formData.depot_id = '';
        if (newVal) {
            if (oldVal) {
                this.$emit('emptyGood');
            }
            this.getSupplierdepotOptions();
        }
    };
    BillHeader.prototype.watchFormDataDepotId = function (newVal, oldVal) {
        if (newVal) {
            if (oldVal) {
                this.$emit('emptyGood');
            }
        }
    };
    BillHeader.prototype.created = function () {
        this.purchaseService = PurchaseService.getInstance();
        this.getSupplierorganOptions();
    };
    BillHeader.prototype.getSupplierorganOptions = function () {
        var _this = this;
        this.purchaseService.getSupplierorganOptions().then(function (res) {
            if (res.data.success) {
                _this.supplierorganOptions = res.data.data;
                _this.formData.organ_id = (res.data.data && res.data.data[0].organ_id) || '';
            }
        });
    };
    BillHeader.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id,
        };
        this.purchaseService.getSupplierdepotOptions(params).then(function (res) {
            if (res.data.success) {
                _this.supplierdepotOptions = res.data.data;
                (res.data.data || []).some(function (item) {
                    if (item.is_organ_default == 1) {
                        _this.formData.depot_id = item.depot_id;
                        return true;
                    }
                    _this.formData.depot_id = '';
                });
            }
        });
    };
    __decorate([
        Prop({
            required: true,
        })
    ], BillHeader.prototype, "formData", void 0);
    __decorate([
        Watch('formData.organ_id')
    ], BillHeader.prototype, "watchFormDataOrganId", null);
    __decorate([
        Watch('formData.depot_id')
    ], BillHeader.prototype, "watchFormDataDepotId", null);
    BillHeader = __decorate([
        Component
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
